import axios from 'axios';
import { authService } from '.';
import { captureException } from '@sentry/nextjs';
import { httpKeepAliveAgent, httpsKeepAliveAgent } from '../helpers/utils/connectionPoolConfig';

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
const TIMEOUT = process.env.NEXT_PUBLIC_TIMEOUT ? parseInt(process.env.NEXT_PUBLIC_TIMEOUT) : 40000;

const apiWithRefreshToken = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  httpAgent: httpKeepAliveAgent,
  httpsAgent: httpsKeepAliveAgent,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiWithRefreshToken.interceptors.response.use(
  async (res) => {
    return res;
  },
  async (error) => {
    const { response } = error;
    // capture error to sentry
    captureException(error);

    if (response?.status === 401) {
      try {
        const response = await authService.authRefreshToken();
        error.config.headers.Authorization = `Bearer ${response.data.token}`;
        return apiWithRefreshToken(error.config);
      } catch (errCatch) {
        return Promise.reject(errCatch);
      }
    }
    return Promise.reject(error);
  }
);

if (process.env.NEXT_PUBLIC_CONNECTION_POOL_STATUS === 'true' && typeof window === 'undefined') {
  setInterval(() => {
    const stats = {
      http: apiWithRefreshToken?.defaults?.httpAgent?.getCurrentStatus(),
      https: apiWithRefreshToken?.defaults?.httpsAgent?.getCurrentStatus(),
    };
    console.log('Connection Pool Stats:', stats);
  }, 30000); // Log every 30 seconds
}

export default apiWithRefreshToken;
